"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeParameters = void 0;
function serializeParameters(inUse, automation, tollFree, portStatuses, q, countryCode) {
    if (portStatuses === void 0) { portStatuses = []; }
    if (q === void 0) { q = null; }
    if (countryCode === void 0) { countryCode = null; }
    var parameters = "";
    parameters = "&inUse=" + inUse + "&automation=" + automation + "&tollFree=" + tollFree;
    if (countryCode) {
        parameters = parameters + ("&countryCode=" + countryCode);
    }
    parameters = parameters + portStatuses.map(function (portStatus) { return "&portStatus=" + portStatus; }).join("");
    if (q) {
        //  Strip all non numerical characters
        var cleanQuery = q.replace(/\D/g, "");
        parameters += "&q=" + cleanQuery;
    }
    return parameters;
}
exports.serializeParameters = serializeParameters;
